import { sleep } from "../../../library-js/animation/sleep";
import { TimePin } from "../../../library-js/animation/TimePin";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { LanguageCode, LanguageCodes } from "../../../library-js/i18n/LanguageCode";
import { MultiString } from "../../../library-js/i18n/MultiString";
import { Cookies } from "../../../library-js/php/cookie-info/Cookies";
import { EmailInput, UserSignUpRequest } from "../../../library-js/php/user/UserSignUpRequest";
import { TemplatesList } from "../../templates/TemplatesList";
import { EmailOverlay } from "../overlay/EmailOverlay";
import { OverlayHint, OverlayHintOptions } from "../overlay/OverlayHint";
import { Rokojori } from "../Rokojori";
import { RokojoriUser } from "./RokojoriUser";



export class LogoutOverlay
{
  static readonly attribute = new ElementAttribute( "logout" );

  static applyOnDocument()
  {
    LogoutOverlay.attribute.forEachInDoc( e => LogoutOverlay.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {  

    OnClick.add
    ( 
      e as HTMLElement, 
      async ()=> 
      { 
        let options = new OverlayHintOptions();
        options.isCancable = true;
        options.isClosable = true;

        let title:MultiString = 
        {
          en: `Logout`,
          de: `Ausloggen`
        };

        let content:MultiString = 
        {
          en: `Do you really want to logut?`,
          de: `Möchtest du dich ausloggen?`
        };
        
        let language = Rokojori.$.pageHandler.currentLanguage as LanguageCode;

        let result = await OverlayHint.hint( title[ language ], content[ language ], options );   
        
        if ( ! result.confirmed )
        {
          return;
        }

        let pin = TimePin.create();
        Rokojori.$.showLoaderScreen( { en:"LOGGING OUT", de:"LOGGE AUS" } );
        let response = await Rokojori.$.userSystem.logout(); 

        console.log( "Logout-Response", response );

        // if ( ! response.hasError )
        // {
        //   let user = Rokojori.$.user;
        //   await Cookies.set( Rokojori.phpContext, user.tokenName, "" );
        //   await Cookies.set( Rokojori.phpContext, user.tokenRefreshName, ""  );
        // }

        // await Rokojori.$.user.checkLoginStatus();

        await pin.forMS( 1000 );

        pin.now();

        Rokojori.$.hideLoaderScreen();
        await pin.forMS( 300 );

        let title2:MultiString = 
        {
          en: `Bye Bye`,
          de: `Bye Bye`
        };

        let content2:MultiString = 
        {
          en: `You are logged out.`,
          de: `Du bist nun ausgeloggt.`
        };

        let options2 = new OverlayHintOptions();
        options2.isCancable = false;
        options2.isClosable = true;

        OverlayHint.hint( title2[ language ], content2[ language ], options2 );   



      } 
    );
  }

}